module.exports = __webpack_public_path__ + "static/media/Heart_ON@3x.3a08b435.png";